/**
 * Theme: Hyper - Responsive Bootstrap 5 Admin Dashboard
 * Author: Coderthemes
 * Module/App: Layout Js
 */

// LeftSidebar
!function ($) {
    'use strict';

    var LeftSidebar = function () {
        this.body = $('body'),
        this.window = $(window),
        this.menuContainer = $('#leftside-menu-container');
    };

    // Initilizes the left menu
    LeftSidebar.prototype.init = function() {
        var self = this;

        self.body.attr('data-leftbar-theme', 'dark');

        // Hide sidebar on small screens by default, show on large screens
        var updateSidebarState = function() {
            // Only auto-adjust if user hasn't manually toggled
            if (self.body.hasClass('sidebar-manual-toggle')) {
                return;
            }

            if (self.window.width() < 992) {
                // On small screens (< lg breakpoint), hide the sidebar
                if (!self.body.hasClass('sidebar-disable')) {
                    self.body.addClass('sidebar-disable');
                }
            } else {
                // On large screens, show the sidebar
                if (self.body.hasClass('sidebar-disable')) {
                    self.body.removeClass('sidebar-disable');
                }
            }
        };

        // Check on page load
        updateSidebarState();

        // Check on window resize
        self.window.on('resize', function() {
            updateSidebarState();
        });

        // Collapse/expand the left menu on the hamburger icon click
        $(document).on('click', '.button-menu-mobile', function(e) {

            // Ensure that WTableViews resize when the menu is toggled
            window.onresize();

            e.preventDefault();

            self.body.toggleClass('sidebar-disable');

            // Keep track of users who manually hid the sidebar.
            // If user toggles it back to visible, resume automatic behavior
            if (self.body.hasClass('sidebar-disable')) {
                self.body.addClass('sidebar-manual-toggle');
            } else {
                self.body.removeClass('sidebar-manual-toggle');
            }
        });
    }

    $.LeftSidebar = new LeftSidebar, $.LeftSidebar.Constructor = LeftSidebar
}(window.jQuery),

// Initialize the left side bar in the main application
function ($) {
    'use strict';

    $.LeftSidebar.init();

}(window.jQuery);
